export const DEFAULT_PRELOAD_COUNT = 8;

// Block problematic extensions on server rendering; FF is stringly-typed, macro names
// in the FF are comma-separated, such as "jira,include,decisionReport"
export const FG_SSR_EXTENSIONS_BLOCKLIST = 'confluence-extensions-server-render-blocklist';
